import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaintenanceDetailComponent } from './maintenance-detail.component';
import { GlobalModulesModule } from '../../global-modules/global-modules.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [MaintenanceDetailComponent],  
  exports: [MaintenanceDetailComponent],
})
export class MaintenanceDetailModule { }
